export const firebaseConfig = {
  apiKey: 'AIzaSyAmrv372h8otvJv6mBdHZzywPn5d6h6oPc',
  authDomain: 'inbox-291119.firebaseapp.com',
  databaseURL: 'https://inbox-291119.firebaseio.com',
  projectId: 'inbox-291119',
  storageBucket: 'inbox-291119.appspot.com',
  messagingSenderId: '133184929067',
  appId: '1:133184929067:web:aa3e2d0c6ccf993462596e',
  measurementId: 'G-MQLC4B4Q53',
};
